import React from 'react';
import { StageCard } from './StageCard';
import { LoanData } from '../types/loan';
const STAGE_ORDER: LoanData['stage'][] = ['Submitted', 'Suspended', 'AWC', 'All In', 'CTC', 'Scheduled', 'Closed'];
const STAGE_COLORS: Record<LoanData['stage'], string> = {
  Submitted: '#0f4496',
  Suspended: '#0f4496',
  AWC: '#0f4496',
  'All In': '#0f4496',
  CTC: '#0f4496',
  Scheduled: '#0f4496',
  Closed: '#0f4496'
};
function groupByStage(data: LoanData[]) {
  const groups: Record<string, LoanData[]> = {};
  for (const stage of STAGE_ORDER) {
    groups[stage] = [];
  }
  for (const loan of data) {
    if (groups[loan.stage]) {
      groups[loan.stage].push(loan);
    }
  }
  return groups;
}
interface LoanTableProps {
  loans: LoanData[];
  onUpdateLoan: (loan: LoanData) => void;
}
export function LoanTable({
  loans,
  onUpdateLoan
}: LoanTableProps) {
  const grouped = groupByStage(loans);
  return <div className="w-full flex flex-col space-y-4 pb-10" data-id="element-7">
      {STAGE_ORDER.map(stage => {
      const stageLoans = grouped[stage];
      if (!stageLoans || stageLoans.length === 0) return null;
      return <StageCard key={stage} stage={stage} loans={stageLoans} accentColor={STAGE_COLORS[stage]} onUpdateLoan={onUpdateLoan} data-id="element-8" />;
    })}
    </div>;
}